type Factory = (destroy: () => void) => void

export class DestroyablesQueue {
  private activeCount = 0
  private waiting: Factory[] = []

  private readonly size: number
  private readonly afterLastDestroyed: () => void
  private readonly beforeFirstCreated: () => void

  constructor(
    config: Partial<{
      size: number
      beforeFirstCreated: () => void
      afterLastDestroyed: () => void
    }>,
  ) {
    this.size = config.size ?? 1
    this.beforeFirstCreated = config.beforeFirstCreated ?? (() => {})
    this.afterLastDestroyed = config.afterLastDestroyed ?? (() => {})
  }

  add(factory: Factory): void {
    if (this.waiting.length === 0 && this.activeCount === 0) {
      this.beforeFirstCreated()
    }
    if (this.size > this.activeCount) {
      this.build(factory)
    } else {
      this.waiting.push(factory)
    }
  }

  private build(factory: Factory): void {
    this.activeCount++
    factory(() => {
      this.activeCount--
      const nextFactory = this.waiting.shift()
      if (nextFactory) {
        this.build(nextFactory)
      } else if (!this.activeCount) {
        this.afterLastDestroyed()
      }
    })
  }
}
